import React, { useEffect, useRef, useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import TextField from '@mui/material/TextField';
import AddCircleOutlinedIcon from '@mui/icons-material/AddCircleOutlined';
import IconButton from '@mui/material/IconButton';
import { useTheme } from '@mui/material/styles';
import socket from './socket';

function CandleStickChart({ roomId }) {
  const [chartData, setChartData] = useState(null);
  const [stock, setStock] = useState('IBM')
  const canvasRef = useRef(null);
  const contextRef = useRef(null);
  const [isDrawing, setIsDrawing] = useState(false);
  const pointsRef = useRef([]);
  const theme = useTheme();

  const handleStockChange = (event) => {
    setStock(event.target.value);
  };

  const sendStock = () => {
    socket.emit('send_stock', { stock, roomId });
    fetchStockData(stock)
  };

  useEffect(() => {
    if (socket) {
      socket.on('set_send_stock', (data) => {
        if (data.roomId === roomId) {
          setStock(data.stock);
          console.log(data.stock)
          fetchStockData(data.stock)
        }
      });
    }
    return () => {
      if (socket) {
        socket.off('set_send_stock');
      }
    };
  }, [socket, roomId]);

  const fetchStockData = async (current_stock) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_BACK_END_URL}/stocks/candlestick/${current_stock}`);
      const data = await response.json();
      setChartData(data);
    } catch (error) {
      console.error('Error fetching chart data:', error);
    }
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_BACK_END_URL}/stocks/candlestick/IBM`);
        const data = await response.json();
        setChartData(data);

        const canvas = canvasRef.current;
        if (!canvas || !socket || !roomId) {
          return;
        }

        const context = canvas.getContext('2d');
        context.strokeStyle = '#000000';
        context.lineWidth = 2;
        contextRef.current = context;

        const handleNewLineDrawn = (data) => {
          console.log('data ', data);
          contextRef.current.beginPath();
          contextRef.current.moveTo(data.points[0].offsetX, data.points[0].offsetY);

          data.points.forEach((point) => {
            contextRef.current.lineTo(point.offsetX, point.offsetY);
            contextRef.current.stroke();
          });

          contextRef.current.closePath();
        };

        socket.on('new_line_drawn', handleNewLineDrawn);

        return () => {
          socket.off('new_line_drawn', handleNewLineDrawn);
        };
      } catch (error) {
        console.error('Error fetching chart data:', error);
      }
    };

    fetchData();
  }, [roomId]); // add dependencies as needed

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) {
      return;
    }

    const context = canvas.getContext('2d');
    context.strokeStyle = '#000000';
    context.lineWidth = 2;
    contextRef.current = context;

    const startDrawing = (event) => {
      const offsetX = event.offsetX;
      const offsetY = event.offsetY;
      contextRef.current.beginPath();
      contextRef.current.moveTo(offsetX, offsetY);
      setIsDrawing(true);
    };

    const finishDrawing = () => {
      contextRef.current.closePath();
      setIsDrawing(false);
      // Emit line data
      socket.emit('line_drawn', { roomId: roomId, points: pointsRef.current });
      pointsRef.current = [];
    };

    const draw = (event) => {
      if (!isDrawing) {
        return;
      }
      const offsetX = event.offsetX;
      const offsetY = event.offsetY;
      contextRef.current.lineTo(offsetX, offsetY);
      contextRef.current.stroke();
      // Add point to points array
      pointsRef.current = [...pointsRef.current, { offsetX, offsetY }];
    };

    canvas.addEventListener('mousedown', startDrawing);
    canvas.addEventListener('mouseup', finishDrawing);
    canvas.addEventListener('mousemove', draw);

    return () => {
      canvas.removeEventListener('mousedown', startDrawing);
      canvas.removeEventListener('mouseup', finishDrawing);
      canvas.removeEventListener('mousemove', draw);
    };
  }, [chartData, isDrawing]);


  if (chartData) {
    const { stocks, days, low, close, open, high } = chartData;

    const numericLow = low.map(parseFloat);
    const numericClose = close.map(parseFloat);
    const numericOpen = open.map(parseFloat);
    const numericHigh = high.map(parseFloat);

    const series = [
      {
        data: days.map((day, index) => ({
          x: new Date(day),
          y: [numericOpen[index], numericHigh[index], numericLow[index], numericClose[index]],
        })),
      },
    ];

    const options = {
      chart: {
        type: 'candlestick',
      },
      title: {
        text: stock,
      },
      xaxis: {
        type: 'datetime',
      },
      yaxis: {
        tooltip: {
          enabled: true,
        },
      },
    };

    return (
      <div><TextField
        required
        id="outlined-required"
        label="Stock Ticker"
        defaultValue={stock}
        value={stock} onChange={handleStockChange}
        InputProps={{
          style: { color: theme.palette.text.secondary },
        }}

      />
        {/* <input type="text" value={stock} onChange={handleStockChange} placeholder="Enter stock ticker" /> */}
        <IconButton onClick={sendStock}><AddCircleOutlinedIcon sx={{ fontSize: 30, color: theme.palette.primary.main, mb: "30px" }} /></IconButton>
        {/* your existing JSX code */}
        <div style={{ position: 'relative', width: '700px', height: '400px' }}>
          <ReactApexChart options={options} series={series} type="candlestick" height="100%" width="100%" style={{ zIndex: 1 }} />
          <canvas
            ref={canvasRef}
            width="700px"
            height="400px"
            style={{
              position: 'absolute',
              top: '0',
              left: '0',
              border: '1px solid #000000',
              zIndex: 2,
            }}
          />
        </div>
      </div>
    );
  } else {
    // Return a loading spinner or some placeholder content
    return <div>Loading...</div>;
  }
}

export default CandleStickChart;
